"use strict";

import {getPrefixedDataSet} from '@elements/data-set-utils';
import {onFind} from "@elements/init-modules-in-scope";
import {findIn, on} from "@elements/dom-utils";

const defaultOptions = {
    video: false,
    animateThumb: false,
    download: false,
    counter: false,
    zoom: false
};

const defaultSelectors = {
    base: '.js-lightbox',
    item: '.js-lightbox__item'
};

export function init(options = defaultOptions, selectors = defaultSelectors) {

    onFind(selectors.base, function (baseElement) {
        createLightbox(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createLightbox(lightbox, options = defaultOptions, selectors = defaultSelectors) {

    let lightboxItems = findIn(selectors.item, lightbox);

    let elementOptions = {
        ...defaultOptions,
        ...options,
        ...getPrefixedDataSet('lightbox', lightbox)
    };

    return import('lightgallery.js').then(function () {

        if (elementOptions.video) {
            /* the following imports are only needed if there are videos in your lightGallery*/
            /* IMPORTANT: Do not forget to add 'lg-video-object lg-html5' to video-elements*/
            /* IMPORTANT: The controls attribute must be set on the <video>*/

            import('vimeo-froogaloop2');
            import('lg-video.js');
        }

        if (elementOptions.zoom) {
            import('lg-zoom.js');
        }

        lightGallery(lightbox, {
            ...elementOptions,
            selector: selectors.item,
        });

        //prevent isClickable
        const lightboxClickHandler = evt => {
            evt.stopImmediatePropagation();
        };

        if (lightboxItems){
            on('click', lightboxClickHandler, lightboxItems);
        }

        return window.lgData[lightbox.getAttribute('lg-uid')];
    });

}
